import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import QueueAnim from "rc-queue-anim";
import { tryNow } from "../../utils";
import { TryOn } from "../../components/TryOn";

export const HomeBanner = ({
  tipOne,
  title,
  description,
  actions,
  bannerImg,
} = {}) => {
  const { t } = useTranslation();
  return (
    <div className="home-banner">
      <div className="inner">
        <div className="banner-content">
          <h1 className="slogn">{title || t("home.banner.title")}</h1>
          <div className="descrption">
            {description || t("home.banner.subtitle")}
          </div>
          {actions || (
            <span data-log="banner/signup">
              <TryOn />
            </span>
          )}
          <div className="tip-warp">
            <div className="tip">
              <i className="icon authing-icon authing-checkbox-circle-fill checked"></i>
              {t("home.banner.try-function-tip")}
            </div>
            <div className="tip">
              <i className="icon authing-icon authing-checkbox-circle-fill checked"></i>
              <span>{tipOne || t("home.banner.try-time-tip")}</span>
            </div>
          </div>
        </div>
        <div className="banner-img">
          <img
            src={
              bannerImg ||
              "//files.authing.co/authing-website/home-banner-tiny-new-update.png"
            }
            alt="Authing统一身份认证平台连接微信钉钉google"
          />
          {/* <img
            src={"//files.authing.co/authing-website/home-banner-new.png"}
            alt="authing banner background"
          /> */}
        </div>
      </div>
    </div>
  );
};
